import React from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { UserShape } from '../../shapes';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import PeopleBoardNotificationsContainer from '../../containers/people_board/people_board_notifications';
import PeopleBoardFollowsContainer from '../../containers/people_board/people_board_follows';
import PeopleBoardFollowersContainer from '../../containers/people_board/people_board_followers';

export default class PeopleBoard extends React.Component {

  static propTypes = {
    user: UserShape,
    params: PropTypes.object
  }

  state = {
    highlightedTab: 'main'
  }

  componentDidMount() {
    this.setHighlightedTab();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.params.tab !== this.props.params.tab ) {
      this.setHighlightedTab();
    }
  }

  render() {
    let boardContent = null;
    if (this.props.params.tab === 'followers') {
      boardContent = <PeopleBoardFollowersContainer />;
    } else if (this.props.params.tab === 'following') {
      boardContent = <PeopleBoardFollowsContainer />
    } else {
      boardContent = <PeopleBoardNotificationsContainer />
    }

    return (
      <div className='board'>
        { this.renderPeopleBoardHeader() }
        { boardContent }
      </div>
    )
  }

  renderPeopleBoardHeader() {
    return (
      <Fragment>
        <Helmet prioritizeSeoTags>
          <title>People Board</title>
          <meta name="og:title" content="People Board"></meta>
        </Helmet>       
        <div className='header'>
          <h1>People Board</h1>
          <p className='item-meta'>
            <Link to='/people_board/main' className={ this.state.highlightedTab === 'main' ? 'highlighted' : null }>notifications</Link>
            <span className='header-meta-spacer'></span>
            <Link to={ `/people_board/followers` } className={ this.state.highlightedTab === 'followers' ? 'highlighted' : null }>followers</Link> { (this.props.user.get('followersCount') > 0) ? this.props.user.get('followersCount') : null }
            <span className='header-meta-spacer'></span>
            <Link to={ `/people_board/following` } className={ this.state.highlightedTab === 'following' ? 'highlighted' : null }>following</Link> { (this.props.user.get('followsCount') > 0) ? this.props.user.get('followsCount') : null }
          </p>
        </div>
      </Fragment>
    );
  }

  setHighlightedTab() {
    if (this.props.params.tab === 'followers') {
      this.setState({ highlightedTab: 'followers' });
    } else if (this.props.params.tab === 'following') {
      this.setState({ highlightedTab: 'following' });
    } else {
      this.setState({ highlightedTab: 'main' });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/people_board/index.jsx